const DB_NAME = 'lucky_guest_drafts';
const DB_VERSION = 1;
const STORE_NAME = 'drafts';

/**
 * Open IndexedDB database
 */
const openDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onerror = (event) => {
            console.error("IndexedDB error:", event.target.error);
            reject(event.target.error);
        };

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'type' });
            }
        };

        request.onsuccess = (event) => {
            resolve(event.target.result);
        };
    });
};

/**
 * Save or update a draft.
 * @param {string} type - 'lost' or 'found'
 * @param {Object} data - The wizard data (can include File objects)
 */
export const saveDraft = async (type, data) => {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            const store = transaction.objectStore(STORE_NAME);

            const draft = {
                type,
                updatedAt: Date.now(),
                ...data
            };

            const request = store.put(draft);

            request.onsuccess = () => resolve(true);
            request.onerror = (e) => reject(e.target.error);
        });
    } catch (error) {
        console.error("Failed to save draft:", error);
        return false;
    }
};

/**
 * Get a draft by type.
 * @param {string} type - 'lost' or 'found'
 */
export const getDraft = async (type) => {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readonly');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.get(type);

            request.onsuccess = () => resolve(request.result);
            request.onerror = (e) => reject(e.target.error);
        });
    } catch (error) {
        console.error("Failed to get draft:", error);
        return null;
    }
};

/**
 * Delete a draft by type.
 * @param {string} type 
 */
export const deleteDraft = async (type) => {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([STORE_NAME], 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.delete(type);

            transaction.oncomplete = () => {
                console.log(`[deleteDraft] Successfully deleted draft type: ${type}`);
                resolve(true);
            };

            transaction.onerror = (e) => {
                console.error(`[deleteDraft] Transaction error:`, e.target.error);
                reject(e.target.error);
            };

            request.onerror = (e) => {
                console.error(`[deleteDraft] Request error:`, e.target.error);
                // We let transaction.onerror handle the rejection
            };
        });
    } catch (error) {
        console.error("Failed to delete draft:", error);
        return false;
    }
};
